<template>
  <v-container
    fluid
    style="min-height: 0; padding-left: 20px; padding-right: 20px"
  >
    <article class="page text-left mobile-center">
      <section class="fw-section">
        <div class="container">
          <!-- header -->
          <table class="table table-borderless" style="border: none !important">
            <tr>
              <td>
                <router-link to="" @click.native="save()"
                  ><span class="material-icons" style="font-size: 36px">
                    chevron_left
                  </span></router-link
                >
              </td>
              <td style="width: 80%; text-align: left">
                <div class="headerLine">Select drivers</div>
              </td>
              <td style="width: 10%; text-align: right; font-size: 24px"></td>
            </tr>
          </table>
          <hr
            class="hr-solid hr-primary"
            style="border-top-color: ; border-top-width: 1px; opacity: 0.25"
          />
          <div class="row padding-bottom-1x"></div>

          <!-- header -->
          <table class="table table-borderless" style="border: none !important">
            <tbody>
              <tr v-for="(driver, i) in team" :key="i">
                <td scope="row" style="width: 5%; padding: 14px 10px 0px 10px">
                  <v-checkbox
                    v-model="selected"
                    :label="driver.email"
                    :value="driver.id"
                  ></v-checkbox>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row padding-bottom-3x"></div>

          <div class="rowm">
            <div class="row" style="display: block; float: right">
              <button
                class="btn btn-default btn-block btn-ghost"
                @click="newRoute()"
                type="submit"
                v-if="isNewRouteMode"
              >
                Done
              </button>

              <div class="col-sm-3"></div>
              <div class="col-sm-3"></div>
            </div>
          </div>
        </div>
      </section>
    </article>
    <dialogConfirm ref="confirm"></dialogConfirm>
  </v-container>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      team: [],
      selected: [],
    };
  },
  methods: {
    save() {
      this.$store.dispatch("saveDrivers", this.selected).then(() => {
        this.$router.go(-1);
      });
    },
    async showInfo() {
      if (
        await this.$refs.confirm.openInfo(
          "Information",
          "Please select drivers first",
          {
            color: "blue",
          }
        )
      ) {
        // yes
      }
    },

    newRoute() {
      if (this.selected == 0) {
        this.showInfo();
      } else {
        this.$store.dispatch("saveDrivers", this.selected).then(() => {
          this.$router.push({ name: "Stops" });
        });
      }
    },
  },

  created() {
    this.$store.dispatch("getDrivers").then((response) => {
      this.team = response.data.team;
      for (var i = 0; i < this.team.length; i++) {
        if (this.team[i].is_current_driver) {
          this.selected.push(this.team[i].id);
        }
      }
    });
  },
};
</script>

<style scoped>
table tbody {
  /* body takes all the remaining available space */
  flex: 1 1 auto;
  display: block;
  overflow-y: scroll;
  max-height: 500px;
}
</style>